<template>
  <NfcBox
    rounded="unset"
    border="unset"
    shadow="nfc"
    class="mx-auto mb-6 mt-4 w-full rounded-[11px] border-[3px] pb-8 pt-6"
  >
    <div class="flex flex-col items-center justify-center">
      <NfcCurvyText
        :text="impactFormatter.format(totalImpact)"
        text-size="text-[90px] whitespace-nowrap leading-none font-black"
        font="font-Agrandir"
        text-outline-class="text-outline-mobile"
        top-positioning="top-[0.040em]"
        :text-color="campaignColors.text"
        :text-shadow-color="campaignColors.textShadow"
      />
      <NfcCurvyText
        :text="action.unit"
        text-size="text-[20px] whitespace-nowrap leading-none font-black uppercase"
        font="font-Agrandir"
        text-outline-class="text-outline-mobile"
        top-positioning="top-[0.20em]"
        left-positioning="left-[0.08em]"
        :text-color="campaignColors.text"
        :text-shadow-color="campaignColors.textShadow"
      />
    </div>
  </NfcBox>
</template>

<script lang="ts" setup>
import {
  useNfcCampaignAction,
  useNfcCampaignColors,
} from "~/domains/nfc/composables";
import type { NFCType } from "~/domains/nfc/types";

const props = defineProps<{
  type: NFCType;
  campaignId: number;
  totalImpact: number;
}>();

const action = useNfcCampaignAction(() => props.campaignId);
const campaignColors = useNfcCampaignColors(() => props.campaignId);

const impactFormatter = Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});
</script>
